import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_persian_date_picker = _resolveComponent("persian-date-picker", true)!

  return (_openBlock(), _createBlock(_component_persian_date_picker, {
    placeholder: _ctx.placeholder,
    modelValue: _ctx.date,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.date) = $event))
  }, null, 8, ["placeholder", "modelValue"]))
}